import { render, staticRenderFns } from "./volcano.vue?vue&type=template&id=0023fd45&"
import script from "./volcano.vue?vue&type=script&lang=js&"
export * from "./volcano.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports